import { FormEvent, useState, useRef } from "react";
import { Button, Col, Form, FormControl, InputGroup, Row } from "react-bootstrap";
import { OrderItem } from "../../pages/types/Order";
import { numberToCurrency } from "../../utils";

type OrderProductProps = {
    item: OrderItem,
    handleQuantityChange: Function,
    handleDelete: Function,
    loading: boolean,
};

const OrderProduct = (props: OrderProductProps) => {
    const item = props.item;
    const [validated, setValidated] = useState(false);
    const [isValid, setIsValid] = useState<boolean>();
    const [quantity, setQuantity] = useState<number>(item.quantity);
    const inputEl = useRef<HTMLInputElement>(null);
    const [show, setShow] = useState(true);

    const handleSubmit = async (e: FormEvent) => {
        const form = e.currentTarget as HTMLFormElement;
        const newQty = parseInt(inputEl?.current?.value || '0', 10);
        setIsValid(form.checkValidity());
        e.preventDefault();
        e.stopPropagation();
        setValidated(true);
        if (isValid) {
            try {
                await props.handleQuantityChange({ ...item, quantity: newQty });
            } catch (err: any) {
                // Force a refresh of the component.
                setShow(false);
                // Revert to unchanged address.
                setQuantity(item.quantity);
                setShow(true);
            }
        }
    };
    const handleQuantityChange = () => {
        const input = inputEl.current;
        setIsValid(input?.checkValidity());
        setQuantity(parseInt(input?.value || '0', 10));
        setValidated(true);
    };
    const handleDelete = () => {
        props.handleDelete(item);
    }
    const quantityProps: any = {
        ref: inputEl,
        onChange: handleQuantityChange,
        "aria-describedby": "product-quantity",
        type: "number",
        min: item.product.stepQty || 1,
        placeholder: 1,
        defaultValue: item.quantity,
    };
    if (item.product.maxQty) {
        quantityProps.max = item.product.maxQty;
    }
    return <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="align-items-center">
            <Col xs="auto">
                <InputGroup>
                    {show &&
                        <FormControl {...quantityProps} />
                    }
                    {quantity && parseInt(item.quantity.toString(), 10) !== quantity &&
                        <Button variant={isValid && validated ? "primary" : "outline-secondary"} type="submit" disabled={props.loading}>Save</Button>}
                </InputGroup>
            </Col>
            <Col xs="auto">
                Cost: <strong>{numberToCurrency(item?.product?.cost ? item?.product?.cost * item.quantity : 0)}</strong>
            </Col>
            <Col className="text-end">
                <Button variant="link" onClick={handleDelete} disabled={props.loading}>Delete</Button>
            </Col>
        </Row>
    </Form>;
}
export default OrderProduct;